import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AUTH_SIGNIN_ROUTE, AUTH_SIGNUP_ROUTE } from '../shared/constants/routes';
import { AuthSigninComponent } from './auth-signin/auth-signin.component';
import { AuthSignupComponent } from './auth-signup/auth-signup.component';

const routes: Routes = [
  {
    path: AUTH_SIGNIN_ROUTE,
    component: AuthSigninComponent,
  },
  {
    path: AUTH_SIGNUP_ROUTE,
    component: AuthSignupComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
